import { ResourceItem } from "./types";

export type ResourcePresentation = {
  key: "canva" | "google_docs" | "google_drive" | "google_sheets" |
    "pdf" | "word" | "powerpoint" | "excel" | "text" | "website";
  label: string;
  extension: string;
};

const extensionOf = (url: string) => {
  try {
    const pathname = new URL(url, window.location.origin).pathname;
    const fileName = pathname.split("/").pop() || "";
    return fileName.match(/\.([a-z0-9]{1,5})$/i)?.[1]?.toLowerCase() || "";
  } catch {
    return "";
  }
};

export function getResourcePresentation(
  resource: Pick<ResourceItem, "destination_url" | "resource_type" | "resource_type_display">,
): ResourcePresentation {
  const url = resource.destination_url.toLowerCase();
  const extension = extensionOf(resource.destination_url);

  if (url.includes("canva.com/")) return { key: "canva", label: "Canva", extension };
  if (url.includes("docs.google.com/spreadsheets") || url.includes("sheets.google.com")) return { key: "google_sheets", label: "Google Sheets", extension };
  if (url.includes("docs.google.com/document")) return { key: "google_docs", label: "Google Docs", extension };
  if (url.includes("drive.google.com")) return { key: "google_drive", label: "Google Drive", extension };
  if (extension === "pdf") return { key: "pdf", label: "PDF", extension };
  if (["doc", "docx"].includes(extension)) return { key: "word", label: extension.toUpperCase(), extension };
  if (["ppt", "pptx"].includes(extension)) return { key: "powerpoint", label: extension.toUpperCase(), extension };
  if (["xls", "xlsx", "csv"].includes(extension)) return { key: "excel", label: extension.toUpperCase(), extension };
  if (extension === "txt") return { key: "text", label: "TXT", extension };

  const fallbackLabels: Partial<Record<ResourceItem["resource_type"], string>> = {
    google_docs: "Google Docs",
    google_drive: "Google Drive",
    google_sheets: "Google Sheets",
    pdf: "PDF",
    website: "Website",
  };
  return {
    key: resource.resource_type === "website" ? "website" : resource.resource_type,
    label: fallbackLabels[resource.resource_type] || resource.resource_type_display,
    extension,
  };
}
